import {UI} from "../../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage} from "../../../../PanelPage";
import {Messages} from "../../../../../Messages";
import {MerchantButton} from "../../../../../common/MerchantButton";
import {BackButton} from "../../../../../../core/ui/LinkButton.jsx";
import {MessageElement} from "../../../../../widget/ui/MessageElement";
import {SubscriptionFlowHandler} from "../../../../flows/SubscriptionFlowHandler.js";
import {iFrameUserDataService} from "../../../../../services/IFrameUserDataService.js";
import {wrapInSpinner} from "../../../../../../core/ui/LoadingSpinner.jsx";
import {apiCancelSubscription} from "../../../../../../client/state/SubscriptionStore.js";
import {Router} from "../../../../../../stem-core/src/ui/Router.jsx";
import {INLINE_EDIT_SUBSCRIPTION_URLS} from "../../../../PanelConstants.js";


export class EditSubscriptionCancelPanel extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.editSubscriptionCancelTitle,
        };
    }

    @wrapInSpinner
    async cancelSubscription(subscription) {
        await apiCancelSubscription(subscription.id);
        Router.changeURL(INLINE_EDIT_SUBSCRIPTION_URLS.cancelSuccess);
    }

    render() {
        const subscription = SubscriptionFlowHandler.subscriptionToCancel || iFrameUserDataService.getActiveSubscription();
        const {styleSheet} = this;

        return [
            <MessageElement
                className={styleSheet.description}
                message={Messages.editSubscriptionCancelText1(
                    subscription.coverage.name, subscription.formatPrice(),
                    subscription.getActiveUntil().format("MMMM DD, YYYY")
                )}
            />,
            <div className={styleSheet.description}>
                {Messages.editSubscriptionCancelText2}
            </div>,
            <MerchantButton
                label={Messages.editSubscriptionCancelButton}
                onClick={() => this.cancelSubscription(subscription)}
                className={styleSheet.actionButton}
            />,
            <BackButton />,
        ]
    }
}
